import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '@shared/ui/LoadingSpinner';

export interface ProtectedRouteProps {
  children: React.ReactNode;
  allow: boolean;
  isLoading?: boolean;
  redirectTo?: string;
  replace?: boolean;
  preserveLocation?: boolean;
  loadingLabel?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allow,
  isLoading = false,
  redirectTo = '/login',
  replace = true,
  preserveLocation = false,
  loadingLabel = 'Checking access permissions',
}) => {
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background dark:bg-background-dark-primary">
        <LoadingSpinner size="xl" label={loadingLabel} />
      </div>
    );
  }

  if (!allow) {
    const state = preserveLocation ? { from: location } : undefined;
    return <Navigate to={redirectTo} replace={replace} state={state} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
